// src/components/StarSchedule.js
import React from 'react';
import { useAuth } from '../context/AuthContext';
import './StarSchedule.css';

const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

const LocationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

// Public event schedule
const STAR_AGENDA = [
  { time: '8:00 – 8:30 a.m.', activity: 'Check-in', location: 'Reinhart Center (RCE) 1st Floor' },
  { time: '8:45 – 9:05 a.m.', activity: 'Welcome', location: 'RCE 134' },
  { time: '9:10 – 9:30 a.m.', activity: 'Students: Activity with CREW. Parents & Supporters: Coffee Social', location: 'Students: RCE 134. Guests: FSPA Lobby (NRC Lobby & 196 on Fri)' },
  { time: '9:30 – 10:10 a.m.', activity: 'Students: Discussion with Professors & Group Advising. Parents and Guests: Helping Your V-Hawk Take Flight Session', location: 'Students: RCE 201 & 202 / MRC 3rd Floor. Guests: FSPA Lobby (NRC Lobby & 196 on Fri)' },
  { time: '10:10 – 10:40 a.m.', activity: 'Students: Group Advising or Discussion with Faculty. Parents & Guests: Student Wellbeing – Counseling Services and Health Services, Title IX, and Violence Prevention', location: 'Students: MRC 3rd Floor. Guests: FSPA Lobby (NRC Lobby & 196 on Fri)' },
  { time: '10:50 – 11:20 a.m.', activity: 'Home, Sweet, New Home – Residence Life and Orientation', location: 'RCE 134' },
  { time: '11:25 – 11:45 a.m.', activity: 'Taking Care of Business – Financial Aid', location: 'RCE 134' },
  { time: '11:45 a.m. – 12:00 p.m.', activity: "Vic's Career Connects – Academic and Career Development, Handshake, Internships, Work-study, On-Campus Jobs", location: 'RCE 134' },
  { time: '12:00 – 1:00 p.m.', activity: 'Lunch', location: 'The Caf' },
  { time: '12:30 – 1:30 p.m.', activity: 'Student Success Fest and ID Pick-Up', location: 'Student Union' },
  { time: '1:30 p.m.', activity: 'Optional: Residence Hall Tour; Financial Aid Office Hour; Testing at the HUB; Drop-in & 1:1 Advising', location: 'Depart from Union / MRC 2nd & 3rd Floor / Financial Aid Office' },
];

const StarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
  </svg>
);

const STAR_WEEK_ACTIVE = false;

const StarSchedule = () => {
  const { user } = useAuth();
  const star = user?.star;

  if (!STAR_WEEK_ACTIVE || !star || !star.attending) return null;

  return (
    <div className="dashboard-card star-card">
      <h2><StarIcon />STAR Day Schedule</h2>
      <p className="star-day">Your STAR day: <strong>{star.day}</strong></p>
      <ul className="star-agenda">
        {STAR_AGENDA.map((item, i) => (
          <li className="star-agenda-item" key={i}>
            <span className="star-time"><ClockIcon /><span>{item.time}</span></span>
            <div className="star-activity">{item.activity}</div>
            <span className="star-location"><LocationIcon /><span>{item.location}</span></span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StarSchedule;
